import P2Regular from 'components/typography/P2Regular';
import { FaultRow } from 'components/tables/data/fault/types';

/**
 * Column for the device subtype name.
 */
export default function DeviceSubtypeNameColumn({ data: { deviceSubtype } }: { data: FaultRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {deviceSubtype.deviceTypeName}
    </P2Regular>
  );
}
